import css from 'styled-jsx/css';

const styles = css`
  .input-slider-block-container {
    display: flex;
    flex-direction: column;
    padding: 0 16px 8px 16px;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
  }
  .number-input-box-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
    height: 44px;
  }
  .slider-outer-container {
    padding: 11px;
    height: 44px;
  }
  .disabled-min-value {
    font-size: 14px;
    margin-left: 1px;
  }
`;
export default styles;
